var swiper = new Swiper('.mySwiper', {
  spaceBetween: 20, // slides ke beech gap

  autoHeight: true, // active slide ke according height adjust

  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },

  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
});


// document.querySelectorAll('.quotify-request-quote-btn').forEach((btn) => {
//   btn.addEventListener('mouseenter', () => {
//     btn.classList.add('is-hover');
//   });

//   btn.addEventListener('mouseleave', () => {
//     btn.classList.remove('is-hover');
//   });
// });